import React, { useState, useEffect } from "react";

const ScrollRevealSubFooter = () => {
  const [subFooterHeight, setSubFooterHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => {
      const percentage = window.innerWidth < 768 ? 0.25 : 0.4;
      setSubFooterHeight(window.innerHeight * percentage);
    };

    // Initial calculation
    updateHeight();

    // Update on window resize
    window.addEventListener("resize", updateHeight);

    // Cleanup
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <div className="relative z-[90]">
      <div
        className="absolute inset-0 bg-gray-950"
        style={{
          height: `${subFooterHeight}px`,
          clipPath: "polygon(0% 0, 100% 0%, 100% 100%, 0 100%)",
        }}
      >
        <div
          className="relative -top-[100vh]"
          style={{
            height: `calc(100vh + ${subFooterHeight}px)`,
          }}
        >
          <div
            className="sticky"
            style={{
              height: `${subFooterHeight}px`,
              top: `calc(100vh - ${subFooterHeight}px)`,
            }}
          >
            <div className="px-4 sm:px-6 md:px-8 lg:pl-[8vw] lg:pr-[4vw] pt-4 sm:pt-6 md:pt-8">
              {/* Sub-footer content */}
              {/* <div className="text-white font-extrabold tracking-[-0.03em] flex items-center gap-1 sm:gap-2 bg-gray-800 w-fit px-3 py-2 sm:px-4 sm:py-3 md:px-6 md:py-4 rounded-2xl sm:rounded-[28px] text-sm sm:text-base">
                Open Source
                <Image
                  src={sparkleWriggle}
                  alt="sparkle"
                  className="w-4 h-4 sm:w-5 sm:h-5"
                />
              </div> */}
              <div className="text-white text-[20vw] sm:text-[20vw] md:text-[18vw] font-editorial tracking-[-0.05em] font-bold absolute top-[90%] left-[50%] -translate-x-1/2 -translate-y-1/2">
                SwiftStudy
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScrollRevealSubFooter;
